import React from 'react'
import styled from '@emotion/styled'
import { mediaQueriesByDevice } from 'parameters/index'
import { DashboardNav } from './DashboardNav'
import { useAuthState } from 'services/Authentication'
import { useHasMounted } from 'lib/renderWrappers/ClientOnly'
import { Container } from '../../../shared/layout/Container'

interface Props {
	ssrDisplay?: boolean
	children: React.ReactNode
	style?: React.CSSProperties
	layout?: 'fullscreen' | 'default'
}

export const DashboardLayout: React.FC<React.PropsWithChildren<Props>> = ({
	children,
	style = {},
	ssrDisplay = false,
	layout = 'default'
}) => {
	const { userType } = useAuthState()
	const hasMounted = useHasMounted()
	const showSubnav = (hasMounted && userType === 'loggedIn') || ssrDisplay

	switch (layout) {
		case 'fullscreen':
			return (
				<>
					{showSubnav && <DashboardNav />}
					<FullScreenContainer style={style}>{children}</FullScreenContainer>
				</>
			)
		case 'default':
			return (
				<>
					{showSubnav ? <DashboardNav /> : <SubnavShim />}
					<Container>
						<DashboardContainer style={style}>{children}</DashboardContainer>
					</Container>
				</>
			)
	}
}

const SubnavShim = styled.div`
	height: 40px;
`

const DashboardContainer = styled.div`
	padding: 32px 0 96px;

	${mediaQueriesByDevice.mobile} {
		padding: 16px 0 56px;
	}
`
export const FullScreenContainer = styled(DashboardContainer)`
	padding: 0;

	${mediaQueriesByDevice.mobile} {
		padding: 0;
	}
`
